import { Badge } from "@chakra-ui/react";
import { Company } from "@intentsify/types";
import { IntegrationWithLogo } from "../IntegrationsModal.utils";
import { DisabledProvider } from "./Providers/DisabledProvider";
import { ProviderCard } from "./Providers/ProviderCard";

interface IntegrationProviderProps {
  companyId: Company["companyId"];
  integration: IntegrationWithLogo;
}

export const IntegrationProvider = (props: IntegrationProviderProps) => {
  if (!props.integration.connectionId) {
    return (
      <DisabledProvider
        companyId={props.companyId}
        integration={props.integration}
      />
    );
  }

  return (
    <ProviderCard.Root>
      <ProviderCard.Header integration={props.integration}>
        <Badge colorScheme="green">Enabled</Badge>
      </ProviderCard.Header>
    </ProviderCard.Root>
  );
};
